import { useTranslation } from "react-i18next";

import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogHeader,
  AlertDialogTitle,
} from "components/AlertDialog";

import { ReactComponent as SpeechToText } from "assets/speech_to_text.svg";

import type { SessionSummarizingDialogProps } from "./SessionSummarizingDialog.types";

export default function SessionSummarizingDialog({ open }: SessionSummarizingDialogProps) {
  const { t } = useTranslation();
  return (
    <AlertDialog open={open}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <div className="w-20 h-20 m-auto mb-3 rounded-full flex items-center justify-center bg-general-gray-200 border border-general-gray-400">
            <SpeechToText className="w-12 h-12 fill-general-green-800" />
          </div>
          <AlertDialogTitle className="text-center">{t("session.sessionSummarizingDialog.title")}</AlertDialogTitle>
          <AlertDialogDescription className="sr-only">
            {t("session.sessionSummarizingDialog.title")}
          </AlertDialogDescription>
        </AlertDialogHeader>
      </AlertDialogContent>
    </AlertDialog>
  );
}
